import styled from 'styled-components';

interface successProps {
  hasContent: boolean;
}

export const Container = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9000;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
`;

export const Body = styled.div`
  position: fixed;
  background: white;
  padding: 40px 60px 20px 60px;

  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 40rem;
  max-height: 50rem;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
`;

export const Header = styled.div`
  width: 100%;
  height: 3.3em;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: #5f6ce0;

  span {
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    text-overflow: ellipsis;
  }
`;

export const Content = styled.div<successProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  width: 100%;
  max-height: 40rem;
  margin-bottom: 20px;
  overflow: auto;
`;
